import React, { Component } from 'react';
import './Applications.css';
import './SoftWareRes.css';


const Applicationss = (props) => {
    return ( 
        <>
        <h2 className='software'>{props.thesoft}</h2>

        
        </>
     );
}
 
export default Applicationss;